import { useStoreSsPlayer } from '~/stores/softswiss/player';

const initOptions: Record<string, any> = {
  '7bitcasino.com': {
    appId: '3508bd21-935e-40a4-a2b7-6e7cac52170d',
    safari_web_id: 'web.onesignal.auto.1f13959d-363e-4480-ae37-ce4b59dbb72b',
  },
  '7bitcasino9.com': {
    appId: '446c9e26-bf49-48a1-a441-cc7d8f9e9104',
    safari_web_id: 'web.onesignal.auto.42aad723-0313-4434-93db-5c9a006ef44f',
  },
  '7bitcasino8.com': {
    appId: 'fdc44783-8112-4aa8-a0a1-b77cadccb80a',
    safari_web_id: 'web.onesignal.auto.62a04992-e924-4258-8064-560c4d6dc347',
  },
  '7bitcasino14.com': {
    appId: '5689b6e5-e670-4eca-8fd3-28a61cb4d5ad',
  },
  '7bitcasino19.com': {
    appId: 'ce678d5c-267c-49a3-b0f2-0aaf8a90d5e8',
    safari_web_id: 'web.onesignal.auto.1b5e3a9a-fd8d-4cbc-b150-cc0a98b0f0fe',
  },
  '7bitcasino13.com': {
    appId: '0492bb57-98e5-4390-a62a-e57264d06485',
  },
  '7bitcasino88.com': {
    appId: '2da75961-a11f-4a97-81b9-6b0fc02436e0',
  },
  '7bitcasino99.com': {
    appId: 'd0c90bb5-3192-4dca-935c-e6855d03197f',
  },
  '7bitcasino28.com': {
    appId: '9ab2d0bc-2448-450b-887d-b8af1eab054a',
  },
  'stage.7bitcasino.com': {
    appId: '6e2a658c-7f72-4cb3-90b9-caa3540e0b85',
    safari_web_id: 'web.onesignal.auto.6974e7ad-baef-42fd-b71d-7f7df083312f',
  },
  'dev.7bitcasino.com': {
    appId: 'b97e5571-d01d-49fd-978a-eefdbd76c919',
    safari_web_id: 'web.onesignal.auto.0e007fdd-4c29-4efe-85fd-d9ae8478b7ea',
  },
  'local-dev.7bitcasino.com': {
    appId: 'eebe2cd8-f139-41e3-a5dd-a7de6e5dd2dd',
    safari_web_id: 'web.onesignal.auto.69f4c26a-74c4-44a8-8df4-068c09b09538',
  },
  '5553-dev.7bitcasino.com': {
    appId: '96f27ad5-60b1-4ef7-a134-dc81393f6828',
    safari_web_id: 'web.onesignal.auto.3377791d-2467-4a62-9fdc-3aca1a0bc947',
  },
};

const isOneSignalCanBeInited = (): boolean =>
  !!initOptions[window.location.host] &&
  !!(window as any).OneSignal &&
  !(window as any).OneSignal.initialized;

async function pushSubscriptionChangeListener(event, id) {
  if (event.current.token && id) {
    console.log(`The push subscription has received a token!`);
    await window.OneSignal.login(`_7bit_com:${id}`);
    if (!event.current.optedIn) {
      await window.OneSignal.User.PushSubscription.optIn();
    }
  }
}

const initAndOpenPrompt = () => {
  window.OneSignalDeferred = window.OneSignalDeferred || [];
  OneSignalDeferred.push(async function (OneSignal) {
    OneSignal.SERVICE_WORKER_PARAM = { scope: '/onesignal/' };
    OneSignal.SERVICE_WORKER_PATH = 'onesignal/OneSignalSDKWorker.js';
    OneSignal.SERVICE_WORKER_UPDATER_PATH = 'onesignal/OneSignalSDKWorker.js';

    await OneSignal.init({
      ...initOptions[window.location.host],
      autoResubscribe: true,
      serviceWorkerParam: { scope: '/onesignal/' },
      serviceWorkerPath: 'onesignal/OneSignalSDKWorker.js',
      // path: 'onesignal/OneSignalSDKWorker.js',
    });
    loginOneSignal();
  });
  // (window as any).OneSignal = (window as any).OneSignal || [];
  // (window as any).OneSignal.push(function () {
  //   (window as any).OneSignal.SERVICE_WORKER_PARAM = { scope: '/onesignal/' };
  //   (window as any).OneSignal.SERVICE_WORKER_PATH = 'onesignal/OneSignalSDKWorker.js';
  //   (window as any).OneSignal.SERVICE_WORKER_UPDATER_PATH = 'onesignal/OneSignalSDKWorker.js';

  //   (window as any).OneSignal.init({
  //     ...initOptions[window.location.host],
  //   });
  //   console.log((window as any).OneSignal.User, 'asd');
  //   (window as any).OneSignal.showSlidedownPrompt();
  // });
};

export const logoutOneSignal = () => {
  window.OneSignalDeferred?.push(async function (OneSignal) {
    await OneSignal.User.PushSubscription.optOut();
    await OneSignal.logout();
  });
};
const loginOneSignal = () => {
  const storeSsPlayer = useStoreSsPlayer();

  window.OneSignalDeferred = window.OneSignalDeferred || [];

  window.OneSignalDeferred.push(async (OneSignal) => {
    if (!storeSsPlayer.playerId) {
      return;
    }

    await OneSignal.Notifications.requestPermission();

    await OneSignal.User.PushSubscription.optIn();

    const token = await OneSignal.User.PushSubscription.token;
    const optedIn = await OneSignal.User.PushSubscription.optedIn;

    console.log({ token, optedIn });

    if (token && optedIn) {
      await OneSignal.login(`_7bit_com:${storeSsPlayer.playerId}`);
    }

    OneSignal.User.PushSubscription.addEventListener('change', (e) => {
      pushSubscriptionChangeListener(e, storeSsPlayer.playerId);
    });
  });
};

export const initOneSignal = async () => {
  await scriptLoader(
    'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js',
    'one-signal-sdk'
  );
  for (let i = 1; i <= 3; i++) {
    if (isOneSignalCanBeInited()) {
      return initAndOpenPrompt();
    } else if (window.OneSignal && window.OneSignal.initialized) {
      console.log('OneSignal already initialized');
      return loginOneSignal();
    } else {
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }
  }
};
